import { DOCS_URL } from '@constants/constant';

export const QUERY_PIPELINE_EMPTY_YAML_TEMPLATE = `# If you need help with the YAML format, have a look at ${DOCS_URL}docs/create-a-pipeline#create-a-pipeline-using-pipeline-designer.
# This section defines components that you want to use in your pipelines. Each node must have a name and a type. You can also set the component's parameters here.
# The name is up to you, you can give your component a friendly name. You then use components' names when specifying the connections in the pipeline.
# Type is the class path of the component.

# components:
#   component_1: # Give your component a friendly name
#     type: # You can find the component type in documentation on a component's page (here maybe a link to components' docs)
#     init_parameters: # Customize the component's parameters. To use default values, type an empty dictionary like this: '{}'.
#   component_2:
#     type: 
#     init_parameters:
 
# connections:  # Define how the components are connected, you can check components outputs and inputs in documentation
# - sender: component_1.output_name # Here you define the output name this compnent sends to the receiver component
#   receiver: component_2.input_name # Here you define the input name that receives the output of the sender component

# inputs:  # List all components that need query and filters as inputs but aren't getting them from any other component connected to them
#   query:  # These components will receive the query as input
#   - "component_1.question"
#   filters:  # These components will receive a potential query filter as input
#   - "component_1.filters"
# outputs:  # Defines the output of your pipeline, usually the output of the last component
#   documents: "component_2.documents"  # The output of the pipeline is the retrieved documents`;

export const INDEXING_PIPELINE_EMPTY_YAML_TEMPLATE = `# If you need help with the YAML format, have a look at ${DOCS_URL}docs/create-a-pipeline#create-a-pipeline-using-pipeline-designer.
# This section defines components that you want to use in your pipelines. Each node must have a name and a type. You can also set the component's parameters here.
# The name is up to you, you can give your component a friendly name. You then use components' names when specifying the connections in the pipeline.
# Type is the class path of the component.

# components:
#   component_1: # Give your component a friendly name
#     type: # You can find the component type in documentation on a component's page (here maybe a link to components' docs)
#     init_parameters: # Customize the component's parameters. To use default values, type an empty dictionary like this: '{}'.
#   component_2:
#     type: 
#     init_parameters:
 
# connections:  # Define how the components are connected, you can check components outputs and inputs in documentation
# - sender: component_1.output_name # Here you define the output name this compnent sends to the receiver component
#   receiver: component_2.input_name # Here you define the input name that receives the output of the sender component

# inputs:  # List all components that need query and filters as inputs but aren't getting them from any other component connected to them
#   query:  # These components will receive the query as input
#   - "component_1.question"
#   filters:  # These components will receive a potential query filter as input
#   - "component_1.filters"`;
